
import { defineComponent } from 'vue'
import TeamDailyCalendar from '@/components/calendars/team-daily.vue'
import TeamsDropdown from '@/components/teams-dropdown.vue'
export default defineComponent({
  components: { TeamsDropdown, TeamDailyCalendar }
})
